import { Action } from "../actions/types"
import { VehicleAssetMappingType, VehicleAssetMappingActionList } from "../actions/vehicleAssetMappingActions"

const initialValue: Array<VehicleAssetMappingType> = []

const vehicleAssetMappingReducer = (state: Array<VehicleAssetMappingType> = initialValue, action: Action) => {
    switch (action.type) {

        case VehicleAssetMappingActionList.ADD_VEHICLE_ASSET_MAPPING:
            return [
                ...state,
                action.data,
            ]

        case VehicleAssetMappingActionList.UPDATE_VEHICLE_ASSET_MAPPING:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case VehicleAssetMappingActionList.FETCH_VEHICLE_ASSET_MAPPING:
            return action.data

        case VehicleAssetMappingActionList.DELETE_VEHICLE_ASSET_MAPPING:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default vehicleAssetMappingReducer